/**
 * Bike and car segments cannot simply be mirrored when a route is reversed: the road back may be
 * one-way, so their turns are dropped. Reversing therefore routes those segments again in the new
 * direction, after asking first, since the line on the map can change.
 */
export type WheeledProfile = 'bike' | 'car';

const WHEELED: WheeledProfile[] = ['bike', 'car'];

export function isWheeledSegment(lineString: any): boolean {
  return WHEELED.includes(lineString?.lineStringProperties?.profile);
}

export function wheeledProfilesIn(lineStrings: any[] | undefined): WheeledProfile[] {
  const profiles = new Set((lineStrings ?? []).map((line) => line?.lineStringProperties?.profile));
  return WHEELED.filter((profile) => profiles.has(profile));
}

export type ReverseRedrawKind = 'cycling' | 'driving' | 'cycling_and_driving';

export function reverseRedrawKind(profiles: WheeledProfile[]): ReverseRedrawKind {
  const cycling = profiles.includes('bike');
  const driving = profiles.includes('car');
  if (cycling && driving) return 'cycling_and_driving';
  return cycling ? 'cycling' : 'driving';
}
